export function toEmbedUrl(url) {
  if (!url) return "";
  const u = url.trim();
  let m;
  if ((m = u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([\w-]+)/))) {
    return `https://www.youtube.com/embed/${m[1]}`;
  }
  if ((m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/))) {
    return `https://player.vimeo.com/video/${m[1]}`;
  }
  if ((m = u.match(/loom\.com\/(?:share|embed)\/([\w-]+)/))) {
    return `https://www.loom.com/embed/${m[1]}`;
  }
  return u;
}
